var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-button",
            {
              staticClass: "mr-2",
              attrs: { variant: "primary", size: "sm" },
              on: { click: _vm.addMeta }
            },
            [_c("i", { staticClass: "fa fa-tasks" }), _vm._v(" Adicionar Meta")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "mr-2",
              attrs: {
                variant: "primary",
                size: "sm",
                href: "/adm/bonificacao"
              }
            },
            [
              _c("i", { staticClass: "fas fa-arrow-alt-circle-right" }),
              _vm._v(" Pedidos Bonificados")
            ]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "mr-2",
              attrs: {
                variant: "primary",
                size: "sm",
                href: "/adm/metas/graph"
              }
            },
            [
              _c("i", { staticClass: "fas fa-chart-bar" }),
              _vm._v(" Ver Indicadores ")
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "mt-3" }, [_vm._v("Metas")]),
      _vm._v(" "),
      _c(
        "b-card",
        [
          _c(
            "b-col",
            { attrs: { lg: "4" } },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: { "label-for": "filter-input", "label-size": "sm" }
                },
                [
                  _c(
                    "b-input-group",
                    [
                      _c("b-form-input", {
                        attrs: {
                          size: "sm",
                          id: "filter-input",
                          type: "search",
                          placeholder: "Buscar Distribuidor"
                        },
                        model: {
                          value: _vm.filter,
                          callback: function($$v) {
                            _vm.filter = $$v
                          },
                          expression: "filter"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { size: "sm", disabled: !_vm.filter },
                              on: {
                                click: function($event) {
                                  _vm.filter = ""
                                }
                              }
                            },
                            [_vm._v("Limpar")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-table", {
            staticClass: "mt-1",
            attrs: {
              fields: _vm.colunas,
              hover: "",
              items: _vm.dataComputed,
              "current-page": _vm.currentPage,
              "per-page": _vm.perPage,
              "sort-direction": _vm.sortDirection,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              stacked: "md",
              filter: _vm.filter,
              "filter-included-fields": _vm.filterOn,
              "show-empty": "",
              small: ""
            },
            on: {
              "update:sortBy": function($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function($event) {
                _vm.sortDesc = $event
              },
              filtered: _vm.onFiltered
            },
            scopedSlots: _vm._u([
              {
                key: "cell(id)",
                fn: function(row) {
                  return [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.show(row.value)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-edit" })]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage,
              align: "fill",
              size: "sm"
            },
            model: {
              value: _vm.currentPage,
              callback: function($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Meta", size: "lg" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _vm.meta_id > 0
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "warning", size: "sm" },
                          on: {
                            click: function($event) {
                              return _vm.DeletarMeta(_vm.meta_id)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "fa fa-trash" }),
                          _vm._v(" Deletar Meta")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "sm" },
                      on: { click: _vm.SalvaMeta }
                    },
                    [_vm._v("Salvar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.openedModal = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.openedModal,
            callback: function($$v) {
              _vm.openedModal = $$v
            },
            expression: "openedModal"
          }
        },
        [
          _c(
            "b-card",
            [
              _c(
                "b-card-body",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "md-12" },
                        [
                          _c("label", [_vm._v("Selecione o Distribuidor:")]),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              options: _vm.listaDistribuidor,
                              disabled: !_vm.showDistribuidor,
                              onSearch: _vm.loadDistribuidor
                            },
                            model: {
                              value: _vm.distribuidor,
                              callback: function($$v) {
                                _vm.distribuidor = $$v
                              },
                              expression: "distribuidor"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3 mb-3" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "md-6" },
                        [
                          _c(
                            "b-form-radio",
                            {
                              attrs: { name: "some-radios", value: "1" },
                              model: {
                                value: _vm.tipoMeta,
                                callback: function($$v) {
                                  _vm.tipoMeta = $$v
                                },
                                expression: "tipoMeta"
                              }
                            },
                            [_vm._v("Meta por Campanha")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "md-6" },
                        [
                          _c(
                            "b-form-radio",
                            {
                              attrs: { name: "some-radios", value: "2" },
                              model: {
                                value: _vm.tipoMeta,
                                callback: function($$v) {
                                  _vm.tipoMeta = $$v
                                },
                                expression: "tipoMeta"
                              }
                            },
                            [_vm._v("Meta por Mês")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _vm.tipoMeta === "1"
                        ? _c(
                            "b-col",
                            { staticClass: "md-4" },
                            [
                              _c("label", [_vm._v("Campanha:")]),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: { options: _vm.listCampanhas },
                                model: {
                                  value: _vm.campanha,
                                  callback: function($$v) {
                                    _vm.campanha = $$v
                                  },
                                  expression: "campanha"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.tipoMeta === "2"
                        ? _c("b-col", [
                            _c("label", { attrs: { for: "mes" } }, [
                              _vm._v("Mês:")
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mesMeta,
                                  expression: "mesMeta"
                                },
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: ["##/####"],
                                  expression: "['##/####']"
                                }
                              ],
                              attrs: { id: "mes" },
                              domProps: { value: _vm.mesMeta },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.mesMeta = $event.target.value
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mt-3" }, [
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("label", [
                        _vm._v("Meta - "),
                        _c("small", [_vm._v("Quantidade de itens:")])
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.meta,
                            expression: "meta"
                          },
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: [
                              "#",
                              "# ###",
                              "##",
                              "## ###",
                              "###",
                              "### ###"
                            ],
                            expression:
                              "['#', '# ###', '##', '## ###', '###', '### ###']"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.meta },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.meta = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mt-3" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("label", [_vm._v("Observações:")]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.descricao,
                            expression: "descricao"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          rows: "3",
                          placeholder: "Digite algo sobre a meta."
                        },
                        domProps: { value: _vm.descricao },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.descricao = $event.target.value
                          }
                        }
                      })
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-083d9caa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-083d9caa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_metas/List.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-083d9caa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_metas/List.vue
// module chunks = 2